var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 8.67233H0.237793V9.503H17.0617V8.67233Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 7.84167H0.237793V8.67234H17.0617V7.84167Z",
    fill: "#B12233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 7.01102H0.237793V7.84168H17.0617V7.01102Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 9.62167H0.237793V10.4523H17.0617V9.62167Z",
    fill: "#B12233"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 11.283H0.237793V12.1137H17.0617V11.283Z",
    fill: "#B12233"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 10.4524H0.237793V11.283H17.0617V10.4524Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 1.78967H0.237793V2.62034H17.0617V1.78967Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 0.959015H0.237793V1.78968H17.0617V0.959015Z",
    fill: "#B12233"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 2.62033H0.237793V3.45101H17.0617V2.62033Z",
    fill: "#B12233"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 4.40036H0.237793V5.23102H17.0617V4.40036Z",
    fill: "#B12233"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 3.56967H0.237793V4.40035H17.0617V3.56967Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 5.23102H0.237793V6.06168H17.0617V5.23102Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0617 6.06168H0.237793V6.89235H17.0617V6.06168Z",
    fill: "#B12233"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76825 0.959015H0.237793V7.01102H8.76825V0.959015Z",
    fill: "#3C3B6D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.948697 1.19635L1.06718 1.43369H1.30413L1.06718 1.55236L1.18565 1.78969L0.948697 1.67102L0.830219 1.78969V1.55236L0.593262 1.43369H0.948697V1.19635Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05727 1.19635L8.17575 1.43369H8.4127L8.17575 1.55236L8.29423 1.78969L8.05727 1.67102L7.93879 1.78969V1.55236L7.82031 1.43369H8.05727V1.19635Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63588 1.19635L6.75436 1.43369H6.99132L6.75436 1.55236L6.87284 1.78969L6.63588 1.67102L6.5174 1.78969V1.55236L6.39893 1.43369H6.63588V1.19635Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21383 1.19635L5.33231 1.43369H5.56927L5.33231 1.55236L5.45079 1.78969L5.21383 1.67102L5.09536 1.78969V1.55236L4.8584 1.43369H5.21383V1.19635Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79196 1.19635L3.91044 1.43369H4.14739L3.91044 1.55236L4.02892 1.78969L3.79196 1.67102L3.67348 1.78969V1.55236L3.43652 1.43369H3.79196V1.19635Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37057 1.19635L2.48905 1.43369H2.72601L2.48905 1.55236L2.60753 1.78969L2.37057 1.67102L2.25209 1.78969V1.55236L2.01514 1.43369H2.37057V1.19635Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0.948697 2.38303L1.06718 2.62035H1.30413L1.06718 2.85769L1.18565 3.09502L0.948697 2.85769L0.830219 3.09502V2.85769L0.593262 2.62035H0.948697V2.38303Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05727 2.38303L8.17575 2.62035H8.4127L8.17575 2.85769L8.29423 3.09502L8.05727 2.85769L7.93879 3.09502V2.85769L7.82031 2.62035H8.05727V2.38303Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63588 2.38303L6.75436 2.62035H6.99132L6.75436 2.85769L6.87284 3.09502L6.63588 2.85769L6.5174 3.09502V2.85769L6.39893 2.62035H6.63588V2.38303Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21383 2.38303L5.33231 2.62035H5.56927L5.33231 2.85769L5.45079 3.09502L5.21383 2.85769L5.09536 3.09502V2.85769L4.8584 2.62035H5.21383V2.38303Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79196 2.38303L3.91044 2.62035H4.14739L3.91044 2.85769L4.02892 3.09502L3.79196 2.85769L3.67348 3.09502V2.85769L3.43652 2.62035H3.79196V2.38303Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37057 2.38303L2.48905 2.62035H2.72601L2.48905 2.85769L2.60753 3.09502L2.37057 2.85769L2.25209 3.09502V2.85769L2.01514 2.62035H2.37057V2.38303Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0.948697 3.56967L1.06718 3.92568H1.30413L1.06718 4.04435L1.18565 4.28168L0.948697 4.16301L0.830219 4.28168V4.04435L0.593262 3.92568H0.948697V3.56967Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05727 3.56967L8.17575 3.92568H8.4127L8.17575 4.04435L8.29423 4.28168L8.05727 4.16301L7.93879 4.28168V4.04435L7.82031 3.92568H8.05727V3.56967Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63588 3.56967L6.75436 3.92568H6.99132L6.75436 4.04435L6.87284 4.28168L6.63588 4.16301L6.5174 4.28168V4.04435L6.39893 3.92568H6.63588V3.56967Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21383 3.56967L5.33231 3.92568H5.56927L5.33231 4.04435L5.45079 4.28168L5.21383 4.16301L5.09536 4.28168V4.04435L4.8584 3.92568H5.21383V3.56967Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79196 3.56967L3.91044 3.92568H4.14739L3.91044 4.04435L4.02892 4.28168L3.79196 4.16301L3.67348 4.28168V4.04435L3.43652 3.92568H3.79196V3.56967Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37057 3.56967L2.48905 3.92568H2.72601L2.48905 4.04435L2.60753 4.28168L2.37057 4.16301L2.25209 4.28168V4.04435L2.01514 3.92568H2.37057V3.56967Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0.948697 4.87503L1.06718 5.11236H1.30413L1.06718 5.23103L1.18565 5.46837L0.948697 5.3497L0.830219 5.46837V5.23103L0.593262 5.11236H0.948697V4.87503Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05727 4.87503L8.17575 5.11236H8.4127L8.17575 5.23103L8.29423 5.46837L8.05727 5.3497L7.93879 5.46837V5.23103L7.82031 5.11236H8.05727V4.87503Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63588 4.87503L6.75436 5.11236H6.99132L6.75436 5.23103L6.87284 5.46837L6.63588 5.3497L6.5174 5.46837V5.23103L6.39893 5.11236H6.63588V4.87503Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21383 4.87503L5.33231 5.11236H5.56927L5.33231 5.23103L5.45079 5.46837L5.21383 5.3497L5.09536 5.46837V5.23103L4.8584 5.11236H5.21383V4.87503Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79196 4.87503L3.91044 5.11236H4.14739L3.91044 5.23103L4.02892 5.46837L3.79196 5.3497L3.67348 5.46837V5.23103L3.43652 5.11236H3.79196V4.87503Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37057 4.87503L2.48905 5.11236H2.72601L2.48905 5.23103L2.60753 5.46837L2.37057 5.3497L2.25209 5.46837V5.23103L2.01514 5.11236H2.37057V4.87503Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0.948697 6.06168L1.06718 6.29901H1.30413L1.06718 6.41768L1.18565 6.65501L0.948697 6.53634L0.830219 6.65501V6.41768L0.593262 6.29901H0.948697V6.06168Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05727 6.06168L8.17575 6.29901H8.4127L8.17575 6.41768L8.29423 6.65501L8.05727 6.53634L7.93879 6.65501V6.41768L7.82031 6.29901H8.05727V6.06168Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63588 6.06168L6.75436 6.29901H6.99132L6.75436 6.41768L6.87284 6.65501L6.63588 6.53634L6.5174 6.65501V6.41768L6.39893 6.29901H6.63588V6.06168Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21383 6.06168L5.33231 6.29901H5.56927L5.33231 6.41768L5.45079 6.65501L5.21383 6.53634L5.09536 6.65501V6.41768L4.8584 6.29901H5.21383V6.06168Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79196 6.06168L3.91044 6.29901H4.14739L3.91044 6.41768L4.02892 6.65501L3.79196 6.53634L3.67348 6.65501V6.41768L3.43652 6.29901H3.79196V6.06168Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37057 6.06168L2.48905 6.29901H2.72601L2.48905 6.41768L2.60753 6.65501L2.37057 6.53634L2.25209 6.65501V6.41768L2.01514 6.29901H2.37057V6.06168Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34682 5.46835L7.4653 5.70568H7.70226L7.4653 5.82435L7.58378 6.06168L7.34682 5.94302L7.22834 6.06168V5.82435L7.10986 5.70568H7.34682V5.46835Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92495 5.46835L6.04342 5.70568H6.28038L6.04342 5.82435L6.1619 6.06168L5.92495 5.94302L5.80647 6.06168V5.82435L5.68799 5.70568H5.92495V5.46835Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5029 5.46835L4.62138 5.70568H4.85833L4.62138 5.82435L4.73985 6.06168L4.5029 5.94302L4.38442 6.06168V5.82435L4.14746 5.70568H4.5029V5.46835Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08151 5.46835L3.19999 5.70568H3.43695L3.19999 5.82435L3.31847 6.06168L3.08151 5.94302L2.96303 6.06168V5.82435L2.72607 5.70568H3.08151V5.46835Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65963 5.46835L1.77811 5.70568H2.01507L1.77811 5.82435L1.89659 6.06168L1.65963 5.94302L1.54116 6.06168V5.82435L1.3042 5.70568H1.65963V5.46835Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34682 4.28168L7.4653 4.51902H7.70226L7.4653 4.63767L7.58378 4.87501L7.34682 4.75634L7.22834 4.87501V4.63767L7.10986 4.51902H7.34682V4.28168Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92495 4.28168L6.04342 4.51902H6.28038L6.04342 4.63767L6.1619 4.87501L5.92495 4.75634L5.80647 4.87501V4.63767L5.68799 4.51902H5.92495V4.28168Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5029 4.28168L4.62138 4.51902H4.85833L4.62138 4.63767L4.73985 4.87501L4.5029 4.75634L4.38442 4.87501V4.63767L4.14746 4.51902H4.5029V4.28168Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08151 4.28168L3.19999 4.51902H3.43695L3.19999 4.63767L3.31847 4.87501L3.08151 4.75634L2.96303 4.87501V4.63767L2.72607 4.51902H3.08151V4.28168Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65963 4.28168L1.77811 4.51902H2.01507L1.77811 4.63767L1.89659 4.87501L1.65963 4.75634L1.54116 4.87501V4.63767L1.3042 4.51902H1.65963V4.28168Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34682 2.97635L7.4653 3.21368H7.70226L7.4653 3.45102L7.58378 3.68834L7.34682 3.45102L7.22834 3.68834V3.45102L7.10986 3.21368H7.34682V2.97635Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92495 2.97635L6.04342 3.21368H6.28038L6.04342 3.45102L6.1619 3.68834L5.92495 3.45102L5.80647 3.68834V3.45102L5.68799 3.21368H5.92495V2.97635Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5029 2.97635L4.62138 3.21368H4.85833L4.62138 3.45102L4.73985 3.68834L4.5029 3.45102L4.38442 3.68834V3.45102L4.14746 3.21368H4.5029V2.97635Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08151 2.97635L3.19999 3.21368H3.43695L3.19999 3.45102L3.31847 3.68834L3.08151 3.45102L2.96303 3.68834V3.45102L2.72607 3.21368H3.08151V2.97635Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65963 2.97635L1.77811 3.21368H2.01507L1.77811 3.45102L1.89659 3.68834L1.65963 3.45102L1.54116 3.68834V3.45102L1.3042 3.21368H1.65963V2.97635Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34682 1.78967L7.4653 2.02701H7.70226L7.4653 2.14567L7.58378 2.50168L7.34682 2.26434L7.22834 2.50168V2.14567L7.10986 2.02701H7.34682V1.78967Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M5.92495 1.78967L6.04342 2.02701H6.28038L6.04342 2.14567L6.1619 2.50168L5.92495 2.26434L5.80647 2.50168V2.14567L5.68799 2.02701H5.92495V1.78967Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5029 1.78967L4.62138 2.02701H4.85833L4.62138 2.14567L4.73985 2.50168L4.5029 2.26434L4.38442 2.50168V2.14567L4.14746 2.02701H4.5029V1.78967Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08151 1.78967L3.19999 2.02701H3.43695L3.19999 2.14567L3.31847 2.50168L3.08151 2.26434L2.96303 2.50168V2.14567L2.72607 2.02701H3.08151V1.78967Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65963 1.78967L1.77811 2.02701H2.01507L1.77811 2.14567L1.89659 2.50168L1.65963 2.26434L1.54116 2.50168V2.14567L1.3042 2.02701H1.65963V1.78967Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.97e5ac44b27c8805d3d868aaafd5dff9.svg";
export { ForwardRef as ReactComponent };